/* custom.js (12 Sep 2026): pinch zoom and double tap zoom for the product lightbox on touch devices.
   Debut had no zoom on phones at all; this lets customers look at every detail of the whole image. */
(function () {
  if (!window.matchMedia('(hover: none)').matches) return;
  function setup(img) {
    if (img.dataset.zoomReady) return;
    img.dataset.zoomReady = '1';
    var scale = 1, tx = 0, ty = 0, startDist = 0, startScale = 1, lastTap = 0;
    var pts = {}, panStart = null;
    function apply() {
      var w = img.clientWidth, h = img.clientHeight;
      var maxX = 0, maxY = 0;
      var box = img.parentElement.getBoundingClientRect();
      maxX = Math.max(0, w * scale - box.width); maxY = Math.max(0, h * scale - box.height);
      tx = Math.min(0, Math.max(-maxX, tx)); ty = Math.min(0, Math.max(-maxY, ty));
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    img.addEventListener('pointerdown', function (e) {
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      img.setPointerCapture(e.pointerId);
      var keys = Object.keys(pts);
      if (keys.length === 2) { startDist = dist(pts[keys[0]], pts[keys[1]]); startScale = scale; panStart = null; }
      else if (keys.length === 1) {
        var now = Date.now();
        if (now - lastTap < 300) {
          if (scale > 1) { reset(); } else {
            scale = 2.5; var r = img.getBoundingClientRect();
            tx = -(e.clientX - r.left) * (scale - 1); ty = -(e.clientY - r.top) * (scale - 1); apply();
          }
          lastTap = 0;
        } else { lastTap = now; }
        panStart = { x: e.clientX - tx, y: e.clientY - ty };
      }
      e.preventDefault();
    });
    img.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var keys = Object.keys(pts);
      if (keys.length === 2 && startDist) {
        var d = dist(pts[keys[0]], pts[keys[1]]);
        scale = Math.min(4, Math.max(1, startScale * d / startDist)); apply();
      } else if (keys.length === 1 && panStart && scale > 1) {
        tx = e.clientX - panStart.x; ty = e.clientY - panStart.y; apply();
      }
      e.preventDefault();
    });
    function up(e) { delete pts[e.pointerId]; if (Object.keys(pts).length < 2) startDist = 0; if (Object.keys(pts).length === 0) panStart = null; if (scale <= 1.02) reset(); }
    img.addEventListener('pointerup', up); img.addEventListener('pointercancel', up);
    img.closest('product-modal') && new MutationObserver(function () {
      if (!img.closest('product-modal').hasAttribute('open')) reset();
    }).observe(img.closest('product-modal'), { attributes: true, attributeFilter: ['open'] });
  }
  function init() { document.querySelectorAll('product-modal .product-media-modal__content img').forEach(setup); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();


/* Round 33: product/page descriptions carry inline rem font sizes written for Debut (root 16px).
   Dawn's root is 10px, so 0.875rem rendered 8.75px instead of 14px. Convert them to Debut px. */
(function () {
  function fix() {
    document.querySelectorAll('.rte [style*="rem"], .product__description [style*="rem"]').forEach(function (el) {
      if (el.dataset.remFixed) return;
      var m = /font-size:\s*([\d.]+)rem/i.exec(el.getAttribute('style') || '');
      if (!m) return;
      el.dataset.remFixed = '1';
      el.style.fontSize = (parseFloat(m[1]) * 16) + 'px';
    });
  }
  document.addEventListener('DOMContentLoaded', fix);
  document.addEventListener('shopify:section:load', fix);
  fix();
})();
